import React, { useState } from 'react';
import './Login.css';
import { setToken, setUser, API_BASE_URL } from './auth';


function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        setToken(data.token);
        setUser(data.user);
        onLogin(true, data.user);
      } else {
        onLogin(false);
        setError(data.error || 'Falscher Benutzername oder Passwort.');
      }
    } catch (err) {
      onLogin(false);
      setError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-form'>
        <img src={process.env.PUBLIC_URL + '/bank-logo.svg'} alt="login-logo" className='login-logo'/>
        <h1>Login</h1>
        <form onSubmit={handleSubmit}>
            <div className='login-input'>
                <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Benutzername"
                />
            </div>
            <div className='login-input'>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder='Passwort'
                />
            </div>
            <div className='passwort-forgotten'>
              Passwort vergessen?
            </div>
            <div className='submit-area'>
            <button className='submit-login' type="submit" disabled={loading}>
              Einloggen
              {loading && <span className="login-loader"></span>}
            </button>
            </div>
            {error && <div className="login-error">{error}</div>}
            <div className='new-member'>
              Neu? Jetzt registrieren!
            </div>
        </form>
    </div>
  );
}

export default Login;
